/**
 * Single source for the docs sidebar and the prev/next footer links.
 * Order here is reading order.
 */

export interface NavItem {
  title: string;
  href: string;
}

export interface NavGroup {
  label: string;
  items: NavItem[];
}

export const DOCS_NAV: NavGroup[] = [
  {
    label: "Developer guide",
    items: [
      { title: "Introduction", href: "/api" },
      { title: "Quickstart", href: "/api/quickstart" },
      { title: "API key setup", href: "/api/api-keys" },
      // "Pricing & credits" retired with the API: `lib/migration.ts` sends
      // /api/pricing to the migration notice, and credits are sold in AI Suite.
      { title: "API limits", href: "/api/limits" },
    ],
  },
  {
    label: "API reference",
    items: [
      { title: "Upscale an image", href: "/api/reference/upscale" },
      { title: "Retrieve a job", href: "/api/reference/retrieve" },
      { title: "List jobs", href: "/api/reference/list" },
      { title: "Download the result", href: "/api/reference/download" },
      { title: "Cancel a job", href: "/api/reference/cancel" },
      { title: "Webhooks", href: "/api/reference/webhooks" },
      { title: "Errors", href: "/api/reference/errors" },
    ],
  },
];

/** Reading order for prev/next. */
export const READING_ORDER: NavItem[] = DOCS_NAV.flatMap(
  (group) => group.items,
);
